import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { FiscalAssessmentDocumentGroupsUpdateValidationSchema } from '../../../schemas/forwardings/fiscalAssessmentDocumentGroups/fiscalAsssessmentDocumentGroupsUpdateDocuments.schema';
import { MaintenanceFiscalAssessmentDocumentGroupData } from '../../../types/forwardings/fiscalAssessmentEntry/fiscalAssessmentEntry.type';

interface UseMaintenanceFiscalAssessmentDocumentGroupsUpdateDocumentsAppendProps {
  documentGroup: MaintenanceFiscalAssessmentDocumentGroupData;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    FiscalAssessmentDocumentGroupsUpdateValidationSchema
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useMaintenanceFiscalAssessmentDocumentGroupsUpdateDocumentsAppend = ({
  documentGroup,
  options,
}: UseMaintenanceFiscalAssessmentDocumentGroupsUpdateDocumentsAppendProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceFiscalAssessmentDocumentGroupsUpdateDocumentsAppend'],
    mutationFn: (form) => {
      const payload = {
        documents_attributes: form.documents_attributes?.map((document) => ({
          file_attachment_attributes: {
            blob_id: document.blob_id,
          },
        })),
      }

      return privateAxios.put(`/maintenance/fiscal_assessment_document_groups/${documentGroup.id}/update_documents`, payload);
    },
    ...options
  });
}
